import { useRecoilValue } from 'recoil';
import { activeRoomId, roomArea, roomsAtom } from 'pages/common/store/rooms';

export const useIsNeedToResetActiveRoom = (): {
  isNeedToResetActiveRoom: boolean;
} => {
  const selectedRoomId = useRecoilValue(activeRoomId);
  const calculatedRooms = useRecoilValue(roomsAtom);
  const isAreaEnabled = useRecoilValue(roomArea);

  const isAreaTabSelected = !isAreaEnabled;
  const selectedRoom = calculatedRooms.find(room => room.id === selectedRoomId);
  const isSelectedRoomHasOnlyAreaDimension =
    Boolean(selectedRoom?.square) && !Boolean(selectedRoom?.length) && !Boolean(selectedRoom?.width);
  const isNeedToResetActiveRoom = !isAreaTabSelected && isSelectedRoomHasOnlyAreaDimension;

  return {
    isNeedToResetActiveRoom,
  };
};
